import { getSubscriptionApiClient } from "../../shared/apis/sidekick/api-factories";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { toast } from "@shared/services/toast";
import { appLogger } from "@shared/services/app-logger";
import { buildAdminGetUserSubscriptionStatusQueryKey } from "./useAdminGetUserSubscription";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  userId: string;
  invoiceId: string;
};

export const useAdminVoidUserSubscriptionInvoice = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getSubscriptionApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationKey: ["admin-subscription", "void-invoice"],
    mutationFn: async ({ userId, invoiceId }: Params) => {
      const response = await api.subscriptionControllerAdminVoidInvoice({
        userId,
        invoiceId,
      });
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: buildAdminGetUserSubscriptionStatusQueryKey({ userId }),
        });
      }, 1000);
      toast.success(
        `User subscription invoice ${invoiceId} has been voided successfully.`,
      );
      onSuccess?.();
      return response;
    },
    onError: async (error) => {
      const apiError = await apiResponseErrorHandler(error);
      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0]);
        return;
      }
      toast.error(
        `Failed to void user subscription invoice. Please try again later.`,
      );
      appLogger.error(`Failed to void user subscription invoice`, {
        error,
      });
    },
  });

  return mutation;
};
